import { api } from '../api/index.js'

export interface RegisterDeviceTokenInput {
  platform: 'ios' | 'android' | 'ios_voip' | 'android_voip'
  device_token: string
  bundle_id?: string
  environment?: 'sandbox' | 'production'
  app_version?: string
}

export const pushService = {
  async getVapidPublicKey(): Promise<string> {
    const { publicKey } = await api.url('/v1/push/vapid-key').get().json<{ publicKey: string }>()
    if (!publicKey) throw new Error('No VAPID public key returned from server.')
    return publicKey
  },

  async saveSubscription(subscription: PushSubscriptionJSON): Promise<void> {
    await api.url('/v1/push/subscriptions').json(subscription).post().res()
  },

  async removeSubscription(endpoint: string): Promise<void> {
    await api.url('/v1/push/subscriptions').json({ endpoint }).delete().res()
  },

  async registerDeviceToken(input: RegisterDeviceTokenInput): Promise<void> {
    await api.url('/v1/push/subscriptions').json(input).post().res()
  },

  async unregisterDeviceToken(
    deviceToken: string,
    platform?: RegisterDeviceTokenInput['platform'],
  ): Promise<void> {
    await api.url('/v1/push/subscriptions').json({ device_token: deviceToken, platform }).delete().res()
  },
}
